// removed by extract-text-webpack-plugin
module.exports = {"row":"messageOptionItem-module-row-5739b06b33bcd34ccb863014dfebd30c--","read-text":"messageOptionItem-module-read-text-6a459258b31d7c0bfa86c744607f514d--","image":"messageOptionItem-module-image-c044fe78bd5c79e553447e6d1ec03faf--"};


//////////////////
// WEBPACK FOOTER
// /src/components/mailThread/compose/messageHandler/messageOptionItem/messageOptionItem.module.scss
// module id = 1972
// module chunks = 0